<template>
  <div></div>
</template>

<script setup>
import { onMounted } from "vue";
import store from "@/src/store/index.js";

const toFetchProjects = async () => {
  await store.dispatch("projects/fetchProjects");
};

onMounted(() => {
  toFetchProjects();
});
</script>
